import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

const Bullet = styled.div`
  width: 4px;
  height: 16px;

  background: #6c60ff;
  border-radius: 1px;
`;
const ContentsTitle = ({ children }) => (
  <FlexBoxColumn>
    <FlexBox gap={'6px'}>
      <Bullet />
      <TextBox weight={boTheme.font.weight.bold} size={boTheme.font.size.medium} color={boTheme.color.sub1}>
        {children}
      </TextBox>
    </FlexBox>
    <Spacing bottom={'16px'} />
  </FlexBoxColumn>
);

ContentsTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default ContentsTitle;
